import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { PageHeader, Form, Input, Button, Spin, message } from 'antd';

import * as ToolRequest from '../../tools/ToolRequest';
import * as ToolPermission from '../../tools/ToolPermission';

import SpinFull from '../../components/SpinFull';

const formLayout = {
  labelCol: {
    sm: { span: 5 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
  labelWrap: true,
};

const formTailLayout = {
  wrapperCol: {
    sm: { offset: 5, span: 16 },
  },
};

export default function CompanyAddScreen() {
  const history = useHistory();
  const userPermissionsData = useSelector(state => state.userPermissions);

  const isRootAdmin = ToolPermission.hasPermission(userPermissionsData, 'ui:company', 'post');

  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  const onFinish = async (values) => {
    setLoading(true);

    try {
      await ToolRequest.request('POST', '/v1/company', {
        name: values.name.trim(),
        displayName: values.displayName.trim(),
      });

      message.success('Create Company successfully');

      history.push('/company');
    } catch (err) {
      setLoading(false);

      if (err?.response?.data) {
        switch (err.response.data) {
          case 'DUPLICATE_NAME':
            return message.error('Company name is duplicate');
          case 'INVALID_PARAMS':
            return message.error('Invalid parameters. Please check your inputs');
          default:
            return message.error('Unknown errors. Please retry');
        }
      }

      message.error('Unknown error. Please retry');
    }
  };

  if (!isRootAdmin) {
    return <SpinFull />;
  }

  return loaded ? (
    <PageHeader
      title="Add a Company"
      onBack={() => history.push('/company')}
    >
      <Spin spinning={loading}>
        <Form
          {...formLayout}
          onFinish={onFinish}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[
              {
                required: true,
                message: 'Please enter the company name',
              },
            ]}
          >
            <Input
              placeholder="Internal name (unique, lowercase)"
            />
          </Form.Item>

          <Form.Item
            label="Display Name"
            name="displayName"
            rules={[
              {
                required: true,
                message: 'Please enter the display name',
              },
            ]}
          >
            <Input
              placeholder="Display name"
            />
          </Form.Item>

          <Form.Item {...formTailLayout}>
            <Button type="primary" htmlType="submit" block>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </PageHeader>
  ) : <SpinFull />;
}

